import React from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';

const TURNAROUND_TIMES_PATH = '/turnaround-times';

const Turnaround = ({ title, icon: Icon, style, onMouseEnter, onMouseLeave }) => {
  const history = useHistory();

  return (
    <Button
      size="sm"
      className="d-flex align-items-center"
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={() => history.push(TURNAROUND_TIMES_PATH)}
    >
      {Icon && <Icon size={16} className="mr-2 align-text-top" />}
      <span>{title}</span>
    </Button>
  );
};

export default Turnaround;
